import { action, computed, observable } from "mobx";
import CreditUsage from "~/models/CreditUsage";
import NestStore from "./NestStore";
import CreditUsageRepository from "../repository/CreditUsageRepository";

class CreditUsageStore extends NestStore {
  rootStore = null;

  /**
   * @property {Array}
   */
  @observable creditUsages = [];

  /**
   * @property {CreditUsage|null}
   */
  @observable creditUsage = null;

  /**
   * @property {number|null}
   */
  creditUsageId = null;

  /**
   * @property {CreditUsageRepository|null}
   */
  creditUsageRepository = null;

  constructor(rootStore) {
    super();

    this.rootStore = rootStore;

    this.creditUsage = new CreditUsage();
    this.creditUsageRepository = new CreditUsageRepository();

    this.setDefaultSearchParams();
  }

  @action
  loadIndex() {
    this.isLoading = true;

    return Promise.all([this.getAll()]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll() {
    const params = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
    };

    if (this.searchParams.providerId !== "") {
      params.providerId = this.searchParams.providerId;
    }

    if (this.searchParams.tourId !== "") {
      params.tourId = this.searchParams.tourId;
    }

    if (this.searchParams.productId !== "") {
      params.productId = this.searchParams.productId;
    }

    return this.creditUsageRepository.fetch(params).then(response => {
      this.processEntities(response.data.creditUsages);
      this.processPagination(response.data.pagination);
    });
  }

  @action
  processEntities(creditUsages = []) {
    this.creditUsages = [];

    creditUsages.forEach(creditUsageArray => {
      const creditUsage = new CreditUsage(creditUsageArray);

      this.creditUsages.push(creditUsage);
    });
  }

  /**
   * Change the pagination page and fetch the Photo Editing Jobs.
   */
  @action
  changePage(page) {
    this.pagination.currentPage = page;

    return this.loadIndex();
  }

  /**
   * Change the pagination page and fetch the Photo Editing Jobs.
   */
  @action
  search() {
    this.pagination.currentPage = 1;

    return this.loadIndex();
  }

  /**
   * Set default search params.
   */
  @action
  setDefaultSearchParams() {
    this.searchParams.providerId = "";
    this.searchParams.tourId = "";
    this.searchParams.productId = "";
  }

  @computed
  get creditUsageSummary() {
    const creditUsageSummary = {
      amountUsed: 0,
      refunded: 0,
      total: 0,
    };

    this.creditUsages.forEach(creditUsage => {
      if (
        creditUsage === null ||
        typeof creditUsage.creditAccount === "undefined" ||
        typeof creditUsage.creditAccount.amount === "undefined"
      ) {
        return;
      }

      if (creditUsage.creditAccount.amount < 0) {
        creditUsageSummary.amountUsed += Math.abs(creditUsage.creditAccount.amount);
      } else if (creditUsage.creditAccount.amount > 0) {
        creditUsageSummary.refunded += creditUsage.creditAccount.amount;
      }
    }, creditUsageSummary);

    creditUsageSummary.total = creditUsageSummary.amountUsed - creditUsageSummary.refunded;

    return creditUsageSummary;
  }
}

export default CreditUsageStore;
